module.exports = __webpack_public_path__ + "static/img/banner2.93a162e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/banner2.png
// module id = g/NK
// module chunks = 0